module.exports = __webpack_public_path__ + "img/HappyPhoto25.21ff4e51.jpeg";